"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[730],{

/***/ 5864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ClientList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/section-title.jsx
var section_title = __webpack_require__(5715);
// EXTERNAL MODULE: ./components/photo.jsx
var photo = __webpack_require__(4761);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(512);
// EXTERNAL MODULE: ./node_modules/tailwind-merge/dist/bundle-mjs.mjs
var bundle_mjs = __webpack_require__(8388);
;// CONCATENATED MODULE: ./lib/cn.ts


function cn() {
    for(var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++){
        inputs[_key] = arguments[_key];
    }
    return (0,bundle_mjs/* twMerge */.m6)((0,clsx/* clsx */.W)(inputs));
}

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/infinite-moving-cards.jsx
"use client";





var InfiniteMovingCards = function(param) {
    var items = param.items, _direction = param.direction, direction = _direction === void 0 ? "left" : _direction, _speed = param.speed, speed = _speed === void 0 ? "fast" : _speed, _pauseOnHover = param.pauseOnHover, pauseOnHover = _pauseOnHover === void 0 ? true : _pauseOnHover;
    var containerRef = react.useRef(null);
    var scrollerRef = react.useRef(null);
    (0,react.useEffect)(function() {
        var getDirection = function() {
            if (containerRef.current) {
                if (direction === "left") {
                    containerRef.current.style.setProperty("--animation-direction", "forwards");
                } else {
                    containerRef.current.style.setProperty("--animation-direction", "reverse");
                }
            }
        };
        var getSpeed = function() {
            if (containerRef.current) {
                if (speed === "fast") {
                    containerRef.current.style.setProperty("--animation-duration", "20s");
                } else if (speed === "normal") {
                    containerRef.current.style.setProperty("--animation-duration", "40s");
                } else {
                    containerRef.current.style.setProperty("--animation-duration", "80s");
                }
            }
        };
        if (containerRef.current && scrollerRef.current) {
            var scrollerContent = Array.from(scrollerRef.current.children);
            scrollerContent.forEach(function(item) {
                var duplicatedItem = item.cloneNode(true);
                if (scrollerRef.current) {
                    scrollerRef.current.appendChild(duplicatedItem);
                }
            });
            getDirection();
            getSpeed();
            setStart(true);
        }
    }, [
        direction,
        speed
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), start = ref[0], setStart = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: containerRef,
        className: "scroller relative z-20  max-w-7xl overflow-hidden [mask-image:linear-gradient(to_right,transparent,white_20%,white_80%,transparent)]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            ref: scrollerRef,
            className: cn(" flex min-w-full shrink-0 gap-4 py-0 w-max flex-nowrap", start && "animate-scroll", pauseOnHover && "hover:[animation-play-state:paused]"),
            children: items.map(function(item, idx) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "w-[250px] opacity-30 hover:opacity-100 transition-opacity duration-500 h-40 justify-center items-center flex max-w-full relative rounded-2xl flex-shrink-0 px-8 py-2 md:w-[250px]",
                    style: {
                        background: "linear-gradient(180deg, var(--white), var(--white)"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("blockquote", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                "aria-hidden": "true",
                                className: "user-select-none -z-1 pointer-events-none absolute -left-0.5 -top-0.5 h-[calc(100%_+_4px)] w-[calc(100%_+_4px)]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative z-20 mt-2 flex flex-row items-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "flex flex-col gap-1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(photo/* default */.Z, {
                                        image: item.attributes.logo,
                                        objectFit: true
                                    })
                                })
                            })
                        ]
                    })
                }, idx);
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/client-list.jsx




function ClientList(param) {
    var settings = param.settings;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            settings.style == "list" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container mx-auto ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfiniteMovingCards, {
                    items: settings.clients.data,
                    direction: "left",
                    speed: "slow",
                    className: "bg-gray-100"
                })
            }),
            settings.style != "list" && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "client-list",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container  ".concat(settings.style),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col ".concat(settings.style === "text-top" ? "" : "xl:flex-row"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex w-full ".concat(settings.style === "text-top" ? "" : "xl:w-2/5"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(section_title/* default */.Z, {
                                    title: settings.title,
                                    description: settings.description,
                                    style: "text-trust",
                                    className: "w-full"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex w-full ".concat(settings.style === "text-top" ? "" : "xl:w-3/5"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-full flex flex-wrap p-10 lg:py-0 mx-auto",
                                    children: settings.clients.data.map(function(entry) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "pt-0 px-2 flex w-1/2 md:w-1/3 lg:w-1/4  ".concat(settings.style === "text-top" ? "xl:w-1/5" : "", " h-32 items-center justify-center lg:flex-col opacity-30 hover:opacity-80 scale-100 hover:scale-125 transition duration-500 ease-in-out"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(photo/* default */.Z, {
                                                image: entry.attributes.logo
                                            })
                                        }, entry.id.toString());
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
}


/***/ }),

/***/ 7410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ContactBlock; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _lib_global_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5439);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);



function ContactBlock(props) {
    var state = (0,_lib_global_context__WEBPACK_IMPORTED_MODULE_1__/* .useGlobalContext */ .bN)().state;
    var global = state;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col md:flex-row text-center justify-center items-start flex-wrap pt-10",
                children: [
                    global.company.contactInfo.map(function(c, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col justify-center w-full md:basis-1/3 px-8 py-10",
                            children: [
                                c.icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "rounded-[0.25rem] bg-gray-50 text-maturity-500 text-center p-4 mx-auto mb-4",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "flaticon-".concat(c.icon.icon, " text-6xl")
                                    })
                                }),
                                c.title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                    className: "!text-md text-maturity-900",
                                    children: c.title
                                }),
                                c.description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: c.description
                                }),
                                c.phone && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: "tel:".concat(c.phone),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: "text-trust pt-2",
                                        children: c.phone
                                    })
                                }),
                                c.email && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: "mailto:".concat(c.email),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: "text-trust pt-2",
                                        children: c.email
                                    })
                                })
                            ]
                        }, "contact-block-".concat(c.title, "-").concat(index, "+"));
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col justify-center w-full md:basis-1/3 px-8 py-10",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "rounded-[0.25rem] bg-gray-50 text-maturity-500 text-center p-4 mx-auto mb-4",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                    className: "flaticon-location text-6xl"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                className: "!text-md text-maturity-900",
                                children: "Address"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: global.company.name
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                dangerouslySetInnerHTML: {
                                    __html: global.company.address
                                }
                            }),
                            global.company.workingHours && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                className: "mt-4",
                                children: [
                                    "Working Hours: ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                    global.company.workingHours
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 3188:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FeaturedEvent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _section__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4623);
/* harmony import */ var _photo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4761);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);




function FeaturedEvent(props) {
    var events = props.events.data.filter(function(e) {
        return e.attributes.isFeatured;
    });
    var event = events[0];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: event && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_section__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            className: "mt-10 z-10 relative px-6",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "rounded-md shadow-lg border-[1px] border-maturity bg-white overflow-hidden",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "h-30 relative text-center flex items-center justify-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_photo__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            image: event.attributes.coverPhoto
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col md:flex-row",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex p-6 flex-col w-full md:w-2/3 ",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        className: "text-trust !text-xl block normal-case",
                                        children: event.attributes.title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "block my-4",
                                        dangerouslySetInnerHTML: {
                                            __html: event.attributes.shortDescription
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex w-full md:w-1/3 flex-shrink-0 p-6 items-center justify-start md:justify-end",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                    href: "/events/".concat(event.attributes.slug),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: "btn btn-md action-full",
                                        children: "Read more"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 4598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ EventList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _section__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4623);
/* harmony import */ var _photo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4761);
/* harmony import */ var _lib_global_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5439);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);





function EventList(props) {
    var events = props.events.data.filter(function(e) {
        return !e.attributes.isFeatured;
    });
    var state = (0,_lib_global_context__WEBPACK_IMPORTED_MODULE_3__/* .useGlobalContext */ .bN)().state;
    var global = state;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_section__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        className: "mt-10 z-10 relative px-6",
        children: [
            props.title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "text-trust ml-2 block relative z-20",
                dangerouslySetInnerHTML: {
                    __html: props.title
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "grid grid-cols-1 px-2 mt-10 md:grid-cols-2 lg:grid-cols-3 gap-10",
                children: events.map(function(e) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "rounded-md shadow-lg border-[1px] border-maturity bg-white overflow-hidden",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "aspect-video relative text-center flex items-center justify-center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_photo__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    layout: "fill",
                                    image: e.attributes.coverPhoto
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "p-6",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        className: "text-trust !text-xl block normal-case",
                                        children: e.attributes.title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "bg-maturity-100 px-2 py-1 text-xs rounded-md inline-block",
                                        children: new Date(e.attributes.date).toDateString(global.locale)
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "block my-4",
                                        dangerouslySetInnerHTML: {
                                            __html: e.attributes.shortDescription
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        href: "/events/".concat(e.attributes.slug),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            className: "btn action-border",
                                            children: "Read more"
                                        })
                                    })
                                ]
                            })
                        ]
                    }, e.id.toString());
                })
            })
        ]
    });
}


/***/ }),

/***/ 753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HeroSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var motion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5720);
/* harmony import */ var motion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(930);
/* harmony import */ var _photo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4761);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);





function HeroSection(props) {
    var ref, ref1, ref2, ref3;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (props.animation === "scale-on-scroll") {
            // const elem = document.getElementById(`hero-${props.id}`).nextElementSibling;
            // const observer = new IntersectionObserver(callback, { root: null, threshold: 1 });
            // observer.observe(elem);
            // return () => {
            //     observer.disconnect();
            // }
            (0,motion__WEBPACK_IMPORTED_MODULE_4__/* .scroll */ .A)((0,motion__WEBPACK_IMPORTED_MODULE_5__/* .animate */ .j)(document.getElementById("hero-".concat(props.id, "-image")), {
                scale: [
                    1,
                    1.5
                ],
                opacity: [
                    1,
                    -0.5
                ]
            }), {
                target: document.getElementById("hero-".concat(props.id)),
                offset: [
                    "100px start",
                    "end start"
                ]
            });
        }
    }, [
        props
    ]);
    // const callback = (entries, observer) => {
    //     console.log(entries);
    //     setShouldStick(entries[0].isIntersecting)
    // }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        id: "hero-".concat(props.id),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "hero-section relative  ".concat(props.headerCss ? props.headerCss : ""),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative w-full flex",
                children: [
                    ((ref = props.image) === null || ref === void 0 ? void 0 : ref.data) && props.imageAsBackground && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "hero-section-bg absolute z-1 top-0 w-full h-full bg-no-repeat bg-cover bg-opacity-20  bg-center ",
                                style: {
                                    backgroundImage: "url(".concat(props.image.data.attributes.url, ")")
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "container flex relative z-2 ",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "hero-section-content",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: " flex flex-col text-white justify-start",
                                            dangerouslySetInnerHTML: {
                                                __html: props.content
                                            }
                                        }),
                                        props.buttons.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "mt-4",
                                            children: props.buttons.map(function(btn) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                    href: btn.link,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        target: btn.target,
                                                        className: "btn btn-lg mr-2 " + btn.style,
                                                        children: btn.label
                                                    })
                                                }, btn.id.toString());
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    ((ref1 = props.image) === null || ref1 === void 0 ? void 0 : ref1.data) && !props.imageAsBackground && props.Layout == "horizontal" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center justify-start py-[10rem]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    id: "hero-".concat(props.id, "-image"),
                                    className: "flex w-2/5 mx-auto md:w-1/2 relative z-20 pl-8 justify-center",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_photo__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                        image: props.image
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex flex-col w-full p-8 pt-0 md:w-2/3 text-white justify-start",
                                    dangerouslySetInnerHTML: {
                                        __html: props.content
                                    }
                                })
                            ]
                        })
                    }),
                    ((ref2 = props.image) === null || ref2 === void 0 ? void 0 : ref2.data) && !props.imageAsBackground && props.Layout == "vertical" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col items-center justify-center relative mx-auto mb-[20vh]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex flex-col w-full p-8 pt-0 md:w-2/3 text-white justify-center text-center",
                                dangerouslySetInnerHTML: {
                                    __html: props.content
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                id: "hero-".concat(props.id, "-image"),
                                className: "flex w-full mx-auto md:w-full m-0 px-4 xl:p-0 justify-center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "rounded-xl overflow-hidden p-0 m-0 flex",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_photo__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                        image: props.image
                                    })
                                })
                            })
                        ]
                    }),
                    !((ref3 = props.image) === null || ref3 === void 0 ? void 0 : ref3.data) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex items-center justify-start pt-[6rem] pb-[6rem]",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex flex-col w-full p-10 ".concat(!props.full ? "md:w-2/3" : "", " text-white justify-start"),
                                dangerouslySetInnerHTML: {
                                    __html: props.content
                                }
                            })
                        })
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 1833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HeroVideo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);


function HeroVideo(props) {
    var ref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "hero hero-video ".concat(props.className ? props.className : ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "content-wrapper px-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "hero-video-content",
                        dangerouslySetInnerHTML: {
                            __html: props.content
                        }
                    }),
                    props.buttons.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "button-list",
                        children: props.buttons.map(function(btn) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                href: btn.link,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    target: btn.target,
                                    className: "btn btn-lg mr-2 " + btn.style,
                                    children: btn.label
                                })
                            }, btn.id.toString());
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                defaultmuted: "true",
                playsInline: true,
                muted: true,
                autoPlay: true,
                poster: props.poster.data.attributes.url,
                loop: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                    src: props.video.data.attributes.url,
                    type: "video/mp4"
                })
            }),
            ((ref = props.className) === null || ref === void 0 ? void 0 : ref.includes("angled")) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "skew-bottom"
            })
        ]
    });
}


/***/ }),

/***/ 9733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _lib_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4626);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var _photo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4761);
"use client";





var JobList = function(props) {
    // const results = await fetchAPI('/jobs', { locale: 'ro', populate: 'deep,1' });
    // console.log(results);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(true), isLoading = ref[0], setIsLoading = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]), jobs = ref1[0], setJobs = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0), cols = ref2[0], setCols = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        (0,_lib_api__WEBPACK_IMPORTED_MODULE_2__/* .fetchAPI */ .I)("/jobs", {
            locale: "ro",
            fields: [
                "title",
                "slug",
                "short_description"
            ],
            populate: "deep,3"
        }).then(function(results) {
            ;
            setJobs(results.data);
            setCols(results.data.length < 2 ? 1 : results.data.length < 5 ? 2 : 3);
            setIsLoading(false);
        });
    }, [
        setIsLoading,
        setJobs,
        setCols
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "max-w-screen-xl w-full mx-auto",
        children: [
            props.content && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: props.content
                }
            }),
            isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: "Loading..."
            }),
            !isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "jobs gap-20 p-10 xl:p-0 pt-0 -mt-20 mb-20 z-10 relative grid grid-cols-1 md:grid-cols-2 lg:grid-cols-".concat(cols, " ").concat(cols > 1 ? "md:job-spacing" : ""),
                children: jobs.map(function(job) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "image-box",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "image-box-wrapper",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "image flex w-full",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_photo__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        image: job.attributes.image,
                                        objectFit: "cover"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "p-10",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            className: "text-2xl",
                                            children: job.attributes.title
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            dangerouslySetInnerHTML: {
                                                __html: job.attributes.short_description
                                            }
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            href: "/jobs/".concat(job.attributes.slug),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                title: "More information on ".concat(job.attributes.title),
                                                className: "btn action-border rounded-xl",
                                                children: "Mai multe informatii"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }, job.id);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (JobList);


/***/ }),

/***/ 1890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NewsList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _section__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4623);
/* harmony import */ var _photo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4761);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_global_context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5439);






function NewsList(props) {
    var state = (0,_lib_global_context__WEBPACK_IMPORTED_MODULE_5__/* .useGlobalContext */ .bN)().state;
    var global = state;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_section__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        className: "mt-10 z-10 relative px-6",
        children: [
            props.title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "text-trust ml-2 block relative z-20",
                dangerouslySetInnerHTML: {
                    __html: props.title
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "grid grid-cols-1 px-2 my-10 md:grid-cols-2 lg:grid-cols-3 gap-10",
                children: props.news.data.map(function(e, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "rounded-md shadow-lg border-[1px] border-maturity bg-white overflow-hidden",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                href: "/news/".concat(e.attributes.slug),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "aspect-video relative text-center flex items-center justify-center overflow-hidden",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        src: e.attributes.coverPhoto.data.attributes.formats.small ? e.attributes.coverPhoto.data.attributes.formats.small.url : e.attributes.coverPhoto.data.attributes.url,
                                        objectFit: "cover",
                                        alt: e.attributes.coverPhoto.data.attributes.alternativeText,
                                        layout: "fill",
                                        priority: index,
                                        quality: 85,
                                        className: "cursor-pointer"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "p-6",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "bg-maturity-100 px-2 py-1 text-xs rounded-md inline-block",
                                        children: new Date(e.attributes.date).toDateString(global.locale)
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                        href: "/news/".concat(e.attributes.slug),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            className: "text-trust hover:text-trust-500 font-bold mt-4 !text-lg block normal-case cursor-pointer",
                                            children: e.attributes.title
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "block my-4",
                                        dangerouslySetInnerHTML: {
                                            __html: e.attributes.shortDescription
                                        }
                                    })
                                ]
                            })
                        ]
                    }, e.id.toString());
                })
            })
        ]
    });
}


/***/ }),

/***/ 4506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Team; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/person.jsx



function Person(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col basis-full sm:basis-1/2 flex-shrink-0 flex-grow md:flex-grow-0 md:basis-1/3 lg:basis-1/4 p-10",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex w-full mx-auto text-center justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/team/".concat(props.slug),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "transition-all duration-300 hover:scale-110",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: props.photo.data.attributes.url,
                                alt: props.photo.data.attributes.alternativeText,
                                width: props.photo.data.attributes.width,
                                height: props.photo.data.attributes.height,
                                className: "rounded-md overflow-hidden"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col text-center w-full",
                    children: [
                        props.fullName && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/team/".concat(props.slug),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "transition-all duration-300 hover:scale-110",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "text-trust-500 font-semibold text-center text-lg mt-2",
                                    children: props.fullName
                                })
                            })
                        }),
                        props.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            className: "mb-4 font-semibold text-sm min-h-[2.5rem]",
                            children: props.title
                        }),
                        props.shortBio && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "mb-4 min-h-[12rem]",
                            dangerouslySetInnerHTML: {
                                __html: props.shortBio
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/team/".concat(props.slug),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "transition-all duration-300 btn trust-border",
                                children: "Read more"
                            })
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/team.jsx



function Team(param) {
    var people = param.people;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container relative",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-wrap items-start justify-center p-4",
            children: people.map(function(p) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Person, (0,_object_spread/* default */.Z)({}, p.attributes), p.id);
            })
        })
    });
}


/***/ })

}]);